// crewbit-admin/src/components/schedule/MonthHeader.tsx
//
// Schedule Module Phase C C3 — month label + nav arrows for admin Month canvas.
// Mobile uses slim chrome (date label embedded inline) and doesn't ship this file.
//
// Spec: docs/references/schedule/SCHEDULE_MODULE_SPEC_v1.md §4.3.

import { ChevronLeft, ChevronRight } from 'lucide-react';
import { palette, admin } from '../../styles/tokens';

export interface MonthHeaderProps {
  /** First day of the month being displayed. */
  monthStart: Date;
  onPrev?: () => void;
  onNext?: () => void;
  onToday?: () => void;
  trailing?: React.ReactNode;
}

function formatMonthLabel(d: Date): string {
  return d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
}

export function MonthHeader({ monthStart, onPrev, onNext, onToday, trailing }: MonthHeaderProps) {
  const label = formatMonthLabel(monthStart);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '12px 24px', gap: 16,
      backgroundColor: admin.surface,
      borderBottom: `1px solid ${admin.border}`,
    }}>
      <button
        type="button"
        onClick={onPrev}
        aria-label="Previous month"
        style={{ background: 'transparent', border: 'none', padding: 4, cursor: 'pointer' }}
      >
        <ChevronLeft size={20} color={palette.g700} />
      </button>

      <button
        type="button"
        onClick={onToday}
        aria-label={label}
        style={{
          background: 'transparent', border: 'none', cursor: 'pointer',
          fontSize: 17, fontWeight: 600, color: palette.g800, padding: '4px 8px',
        }}
      >
        {label}
      </button>

      <button
        type="button"
        onClick={onNext}
        aria-label="Next month"
        style={{ background: 'transparent', border: 'none', padding: 4, cursor: 'pointer' }}
      >
        <ChevronRight size={20} color={palette.g700} />
      </button>

      {trailing ? <div style={{ marginLeft: 'auto' }}>{trailing}</div> : null}
    </div>
  );
}
